import React from "react";
import styled from "styled-components";
import { FaUserTie, FaTools, FaRocket } from "react-icons/fa";

/* SECTION */
const Section = styled.section`
  width: 100%;
  padding: 60px 16px;
  // background: radial-gradient(circle at top, #fff5ee, #f7f2ff);
  box-sizing: border-box;

  @media (min-width: 768px) {
    padding: 100px 60px;
  }
`;

/* CONTAINER */
const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

/* TITLE */
const Title = styled.h2`
  font-size: 32px;
  font-weight: 800;
  color: #1a1a1a;
  margin-bottom: 12px;
  text-align: center;

  @media (min-width: 768px) {
    font-size: 42px;
  }
`;

const Subtitle = styled.p`
  font-size: 16px;
  color: #555;
  text-align: center;
  max-width: 700px;
  margin: 0 auto 50px;
  line-height: 1.7;
`;

/* GRID */
const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

/* CARD */
const Card = styled.div`
  background: #ffffff;
  border-radius: 18px;
  padding: 36px 28px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 18px 44px rgba(0, 0, 0, 0.12);
  }
`;

/* ICON */
const IconWrap = styled.div`
  width: 64px;
  height: 64px;
  margin: 0 auto 20px;
  border-radius: 50%;
  background: linear-gradient(135deg, #ff8a3d, #d55bff);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 28px;
`;

/* CARD TEXT */
const CardTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 12px;
`;

const CardText = styled.p`
  font-size: 15px;
  color: #555;
  line-height: 1.6;
  margin-bottom: 24px;
`;

/* BUTTON */
const Button = styled.a`
   width: 100%;
  max-width: 220px;
  margin: 0 auto;
  padding: 14px 0;
  font-size: 14px;
  font-weight: 700;
  border-radius: 40px;
  background: linear-gradient(45deg,#ff8a3d,#d55bff);
  color: white;
  border: none;
  cursor: pointer;
  transition: 0.3s ease;
  display: block;

  &:active {
    transform: scale(0.95);
  }

  @media (min-width: 768px) {
    max-width: 200px;
    padding: 12px 0;
  }
`;

/* MAIN COMPONENT */
const ContactMini = () => {
  return (
    <Section id="contact-mini">
      <Container>
        <Title>Get in Touch</Title>
        <Subtitle>
          Whether you’re planning a new product, scaling your business, or need
          reliable technical support — our team is ready to help you move
          forward with confidence.
        </Subtitle>

        <CardsGrid>
          {/* SALES */}
          <Card>
            <IconWrap>
              <FaUserTie />
            </IconWrap>
            <CardTitle>Talk to Our Consulting Team</CardTitle>
            <CardText>
              Get expert guidance on web development, mobile apps, cloud
              solutions, and digital transformation tailored to your business
              goals.
            </CardText>
            <Button href="#contact">Contact Sales</Button>
          </Card>

          {/* SUPPORT */}
          <Card>
            <IconWrap>
              <FaTools />
            </IconWrap>
            <CardTitle>Technical Support & Assistance</CardTitle>
            <CardText>
              Already working with us? Our support team is here to help you with
              updates, bug fixes, performance improvements, and maintenance.
            </CardText>
            <Button href="#support">Get Support</Button>
          </Card>

          {/* PROJECT DISCUSSION */}
          <Card>
            <IconWrap>
              <FaRocket />
            </IconWrap>
            <CardTitle>Start a New Project</CardTitle>
            <CardText>
              Have an idea or requirement in mind? Let’s discuss your project
              and turn your vision into a scalable, high-quality digital
              solution.
            </CardText>
            <Button href="#contact">Start a Project</Button>
          </Card>
        </CardsGrid>
      </Container>
    </Section>
  );
};

export default ContactMini;
